import { combineReducers } from 'redux';
import authReducer from './auth/reducer';
import todoReducer from './todo/reducer';
import camppaignReducer from '@/modules/pid-cms/stores/campaign/reducer';
import layoutReducer from './layout/layout-reducer';
import displayReducer from '@/modules/pid-cms/stores/display/reducer';
import dialogReducer from './dialog/reducer';
import menuUserReducer from './menuUser/reducer';
import tableReducer from './table/reducer';
import isLogin from './login/reducer';
var rootReducer = combineReducers({
    todo: todoReducer,
    auth: authReducer,
    campaign: camppaignReducer,
    layout: layoutReducer,
    display: displayReducer,
    dialog: dialogReducer,
    menuUser: menuUserReducer,
    tableCommon: tableReducer,
    isLogin: isLogin,
});
export default rootReducer;
